import script from "./LandingPagePreLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingPagePreLogin.vue?vue&type=script&setup=true&lang=js"

import "./LandingPagePreLogin.vue?vue&type=style&index=0&id=64fc5f32&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64fc5f32"]])

export default __exports__